import { ApdmCampaignStatus } from './apdm';

export enum AiAgentBundleId {
  Workshop = 'workshop',
  Apdm = 'apdm',
  /** Sales coaching setup inside 知车 AI. */
  SalesCoaching = 'sales_coaching',
}
export enum AiHomeDispatchMode {
  Automatic = 'automatic',
}
export enum AiHomeFeature {
  Assistant = 'assistant',
  Coaching = 'coaching',
  Apdm = 'apdm',
  BusinessIntelligence = 'bi',
  Posters = 'posters',
}
export interface AiHomeSuggestion {
  id: string;
  feature: AiHomeFeature;
  /** The prompt itself; older builds read this. */
  title: string;
  prompt: string;
  /** What the action does for the shop. */
  description: string;
  agent: AiAgentBundleId | null;
  icon: 'assistant' | 'training' | 'campaign' | 'chart' | 'image';
  available: boolean;
}
export interface AiHomeSuggestionsResult {
  asOf: string;
  items: AiHomeSuggestion[];
}
export enum AiHomeActivityKind {
  ApdmCampaign = 'apdm_campaign',
}
/** Mirror of backend `AiHomeCampaignActivity`: a campaign still running. */
export interface AiHomeCampaignActivity {
  kind: AiHomeActivityKind.ApdmCampaign;
  campaignId: string;
  title: string;
  status: ApdmCampaignStatus;
  audience: number;
  attempted: number;
  replied: number;
  /** Leads nobody has followed up yet. */
  newLeads: number;
  /** The caller's conversation that launched it; null when built elsewhere. */
  sessionId: string | null;
  activityAt: string;
}
export type AiHomeActivity = AiHomeCampaignActivity;
export interface AiHomeApdmCounts {
  running: number;
  newLeads: number;
}
export interface AiHomeActivityResult {
  asOf: string;
  /** The latest few, most recent first. */
  items: AiHomeActivity[];
  total: number;
  apdm: AiHomeApdmCounts | null;
}
/** Mirror of backend `AiHomeSession`: one 知车 AI conversation. */
export interface AiHomeSession {
  id: string;
  bundleId: AiAgentBundleId;
  title: string;
  updatedAt: string;
}
/** Mirror of backend `AiHomeSessionsCursor`: where the next page starts. */
export interface AiHomeSessionsCursor {
  updatedAt: string;
  id: string;
}
export interface AiHomeSessionsResult {
  sessions: AiHomeSession[];
  /** Null when this page is the last. */
  next: AiHomeSessionsCursor | null;
  /** Conversations matching the keyword, across all pages. */
  total: number;
}
export interface AiBundleHandoff {
  bundleId: AiAgentBundleId;
  prompt: string;
}
export function parseAiBundleHandoff(value: unknown): AiBundleHandoff | null {
  if (
    !value ||
    typeof value !== 'object' ||
    Array.isArray(value) ||
    Object.getPrototypeOf(value) !== Object.prototype
  )
    return null;
  const item = value as Record<string, unknown>;
  if (
    Object.keys(item).some(key => !['bundleId', 'prompt'].includes(key)) ||
    !Object.values(AiAgentBundleId).includes(
      item.bundleId as AiAgentBundleId,
    ) ||
    typeof item.prompt !== 'string' ||
    !item.prompt.trim() ||
    item.prompt.length > 300 ||
    /[\r\n]/.test(item.prompt)
  )
    return null;
  return {
    bundleId: item.bundleId as AiAgentBundleId,
    prompt: item.prompt.trim(),
  };
}
